import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/modules/authentication'


//import VuexPersistence from 'vuex-persist'


Vue.use(Vuex)

/*const vuexLocal = new VuexPersistence({
  storage: localStorage,
  modules: ['auth']
})*/

export default new Vuex.Store({
  state: {
    loading: false,
    colorBase: '#ffffff',
    colorBoton: '#00695C',//'#eb991c'//'#92d2c4',
    colorBotonRed: '#E57373',
    colorBotonBlue: '#64B5F6'
   
                  
  },
  mutations: {
    setLoading (state, bool){
      state.loading = bool
    }
  },
  actions: {
  },
  modules: {
    auth
  },

 // plugins: [vuexLocal.plugin]
})
